"use strict";

exports.__esModule = true;
exports.prepareSeries = void 0;
var _getDevice = require("../../Device/common/getDevice");
var _echartsForReact = require("echarts-for-react");
var prepareSeries = exports.prepareSeries = function prepareSeries(props) {
  var data = props.data,
    devices = props.devices,
    deviceList = props.deviceList;
  var _accumulateDataByDevi = accumulateDataByDeviceForDataItems({
      data: data,
      devices: devices,
      deviceList: deviceList
    }),
    devicesAccumulatedDataItems = _accumulateDataByDevi.data;
  return prepareDataItemsSeries(devicesAccumulatedDataItems);
};
var accumulateDataByDeviceForDataItems = function accumulateDataByDeviceForDataItems(props) {
  var data = props.data,
    devices = props.devices,
    deviceList = props.deviceList;
  var result = [];
  var maxValue = 0;
  devices.forEach(function (device, index) {
    var _data$index;
    var deviceDataItem = {
      device: (0, _getDevice.getDeviceName)(deviceList, device),
      data: {}
    };
    var deviceDataItemData = {};
    (_data$index = data[index]) == null || _data$index.forEach(function (dataItemData) {
      var value = dataItemData.value;
      if (value != null && value !== "") {
        var numberValue = Number(value);
        if (numberValue > maxValue) {
          maxValue = numberValue;
        }
        if (deviceDataItemData[dataItemData.data_item_name] == null) {
          deviceDataItemData[dataItemData.data_item_name] = [[new Date(dataItemData.timestamp), numberValue]];
        } else {
          deviceDataItemData[dataItemData.data_item_name].push([new Date(dataItemData.timestamp), numberValue]);
        }
      }
    });
    for (var _i = 0, _Object$values = Object.values(deviceDataItemData); _i < _Object$values.length; _i++) {
      var values = _Object$values[_i];
      values.sort(function (a, b) {
        return new Date(a[0]).getTime() - new Date(b[0]).getTime();
      });
    }
    deviceDataItem.data = deviceDataItemData;
    result.push(deviceDataItem);
  });
  return {
    data: result,
    maxValue: maxValue
  };
};
var prepareDataItemsSeries = function prepareDataItemsSeries(deviceDataItems) {
  var result = [];
  deviceDataItems.forEach(function (deviceDataItem) {
    var deviceName = deviceDataItem.device;
    for (var _i2 = 0, _Object$entries = Object.entries(deviceDataItem.data); _i2 < _Object$entries.length; _i2++) {
      var _Object$entries$_i = _Object$entries[_i2],
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      result.push({
        name: deviceName + "-" + key,
        device: deviceName,
        dataItem: key,
        type: "line",
        data: value,
        showSymbol: false,
        markPoint: {
          symbol: "arrow",
          symbolSize: 15,
          symbolRotate: 180,
          data: [{
            type: "max",
            name: "Max",
            label: {
              formatter: "Max: {c}",
              position: "top",
              fontSize: "12"
            }
          }, {
            type: "min",
            name: "Min",
            label: {
              formatter: "Min: {c}",
              position: "bottom",
              fontSize: "12"
            }
          }]
        },
        markLine: {
          data: [{
            type: "average",
            label: {
              formatter: "Avg: {c}",
              position: "end",
              fontSize: "12"
            }
          }, {
            type: "median",
            label: {
              formatter: "Median: {c}",
              position: "start",
              fontSize: "12"
            }
          }]
        }
      });
    }
  });
  return result;
};